import React, { useState } from 'react';
import axios from 'axios';
import "./FormularView.css";
import Spinner from '../image/spinner.svg';
import CheckIcon from '../image/CheckIcon';

import AirplaneIcon from '../image/AirplaneIcon';
import PhoneIcon from '../image/PhoneIcon';
import NameIcon from '../image/NameIcon';
import MailIcon from '../image/MailIcon';

const PHPMAILERENV = (process.env.REACT_APP_PHP_MAILER) ? process.env.REACT_APP_PHP_MAILER : 'http://app.janker-dach.de/backend/index.php';

const isValidFileUploaded=(file)=>{
    const validExtensions = ['png','jpeg','jpg']
    const fileExtension = file.type.split('/')[1]
    return validExtensions.includes(fileExtension)
}

const FormularView = ({SelectedQuestion}) => {
    const valueSelectedQuestion = SelectedQuestion.toString();
    //const valueSelectedQuestion = SelectedQuestion;
    
    const [isLoading, setIsLoading] = useState(false);
    const [sendDataSuccess, setSendDataSuccess] = useState(false);
    const [selectedImage, setSelectedImage] = useState();

    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        name: "",
        nachname: "",
        email: "",
        phone: "",
        street: "",
        zip: "",
        place: "",
        message: "",
        file: "",
        subject: valueSelectedQuestion,
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({...formData, [name]: value});
        setErrors({ ...errors, [name]: "" });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = {};
        const formDataObj = new FormData();
        
        if (formData.name.trim() === "") {
            validationErrors.name = "Bitte ausfüllen!";
        }
        if (formData.nachname.trim() === "") {
            validationErrors.nachname = "Bitte ausfüllen!";
        }
        if (formData.email.trim() === "") {
            validationErrors.email = "Bitte ausfüllen!";
        }
        if (formData.phone.trim() === "") {
            validationErrors.phone = "Bitte ausfüllen!";
        }
        if (formData.street.trim() === "") {
            validationErrors.street = "Bitte ausfüllen!";
        }
        if (formData.zip.trim() === "") {
            validationErrors.zip = "Bitte ausfüllen!";
        }
        if (formData.place.trim() === "") {
            validationErrors.place = "Bitte ausfüllen!";
        }
        if (selectedImage) {
            formDataObj.append("file", selectedImage);
        }
        formDataObj.append('name', formData.name);
        formDataObj.append('nachname', formData.nachname);
        formDataObj.append('street', formData.street);
        formDataObj.append('email', formData.email);
        formDataObj.append('phone', formData.phone);
        formDataObj.append('zip', formData.zip);
        formDataObj.append('place', formData.place);
        formDataObj.append('message', formData.message);
        formDataObj.append('subject', formData.subject);
        
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
        }else{
            setIsLoading(true);

            axios({
                method: 'post',
                url: PHPMAILERENV,
                //headers: {'content-type': 'application/json'},
                headers: {'Content-Type': 'multipart/form-data' },
                data: formDataObj,
            })
            .then((response) => {
                if (response.status == '200') {
                    document.querySelector(".success").style.cssText = "display: block; text-align: center;";
                    setSendDataSuccess(true);
                    document.body.className += ' app-end';
                    window.scrollTo(0, 0);

                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'konfiSubmit',
                        'formId': 'app',
                        'formLocation': 'kontakt',
                        'formMail': formData.email
                    });

                }else{
                    console.log('Nein');
                }
            })
            .catch((error) => {
                console.log('Error submittig from:', error);
                setIsLoading(false);
            });

        }
    }

    const showQuestionData = () => {
        console.log(SelectedQuestion);
    }

    const handleFileChange = async (e) => {
        //console.log(e.target.files);



        if(e.target.files.length < 1){
            return;
        }
        const file = e.target.files;
        if(isValidFileUploaded(file[0])){
            setSelectedImage(file[0]);
            setFormData({...formData, file: file[0]});
        }else{
            console.log('failed');
        }

        if(!file){
            return;
        }
        try {
            const imgUrl = await file?.[0];
            console.log('Upload Success: ' + imgUrl);
        } catch(error) {
            console.log(error);
        }
    }

    return (
        <>
            {!sendDataSuccess ? <h3>Wie können wir Sie am besten erreichen?</h3> : null}
            
            <form onSubmit={handleSubmit}>
                <div className="success display-none">Vielen Dank für Ihre Anfrage! <br />Wir melden uns schnellstmöglich bei Ihnen telefonisch oder per E-Mail.</div>
                {!sendDataSuccess ? 
                    <div className="form-input-handler">

                    <div className="form-input-item">                    
                        <div className="item-handler">
                            <label htmlFor="name">
                            Vorname*:{" "}
                            {errors.name && (
                                <span className="validation-message">{errors.name}</span>
                            )}
                            </label>
                            <div className="item-handler-input max-input">
                                <input type="text" id="name" className="full-width" name="name" 
                                    value={formData.name} 
                                    onChange={handleInputChange} 
                                />
                                <i><NameIcon/></i>
                            </div>
                        </div>
                        <div className="item-handler">
                            <label htmlFor="nachname">
                            Nachname*:{" "}
                            {errors.nachname && (
                                <span className="validation-message">{errors.nachname}</span>
                            )}
                            </label>
                            <div className="item-handler-input">
                                <input type="text" id="nachname" className="full-width" name="nachname" 
                                    value={formData.nachname} 
                                    onChange={handleInputChange} 
                                />
                                <i><NameIcon/></i>
                            </div>
                        </div>
                    </div>
                    <div className="form-input-item">
                        <div className="item-handler item-handler-33">
                            <label htmlFor="street">
                            Straße, Hsnr.*:{" "}
                            {errors.street && (
                                <span className="validation-message">{errors.street}</span>
                            )}
                            </label>
                            <div className="item-handler-input max-input">
                                <input type="text" id="street" className="full-width" name="street" 
                                    value={formData.street} 
                                    onChange={handleInputChange} 
                                />
                                <i><NameIcon/></i>
                            </div>
                        </div>
                        <div className="item-handler item-handler-33">
                            <label htmlFor="zip">
                            PLZ*:{" "}
                            {errors.name && (
                                <span className="validation-message">{errors.zip}</span>
                            )}
                            </label>
                            <div className="item-handler-input max-input">
                                <input type="text" id="zip" className="full-width" name="zip" 
                                    value={formData.zip} 
                                    onChange={handleInputChange} 
                                />
                                <i><NameIcon/></i>
                            </div>
                        </div>
                        <div className="item-handler item-handler-33">
                            <label htmlFor="place">
                            Ort*:{" "}
                            {errors.name && (
                                <span className="validation-message">{errors.place}</span>
                            )}
                            </label>
                            <div className="item-handler-input">
                                <input type="text" id="place" className="full-width" name="place" 
                                    value={formData.place} 
                                    onChange={handleInputChange} 
                                />
                                <i><NameIcon/></i>
                            </div>
                        </div>
                    </div>
                    <div className="form-input-item">
                    <div className="item-handler">
                        <label htmlFor="email">E-Mail*:
                        {errors.email && (
                            <span className="validation-message">{errors.email}</span>
                        )}
                        </label>
                        <div className="item-handler-input max-input">
                            <input type="email" id="email" className="full-width" name="email" 
                                value={formData.email} 
                                onChange={handleInputChange} 
                            />
                            <i><MailIcon/></i>
                        </div>
                    </div>
                    <div className="item-handler">
                        <label htmlFor="phone">
                        Telefonnummer*:{" "}
                        {errors.phone && (
                            <span className="validation-message">{errors.phone}</span>
                        )}
                        </label>
                        <div className="item-handler-input">
                            <input type="text" id="name" className="full-width" name="phone" 
                                value={formData.phone} 
                                onChange={handleInputChange} 
                            />
                            <i><PhoneIcon/></i>               
                        </div>
                    </div>
                    </div>
                    <div className="item-handler">
                    <label htmlFor="message">
                    Nachricht:{" "}
                    </label>
                    <div className="item-handler-input">
                        <textarea type="text" id="message" className="full-width" name="message" 
                            value={formData.message} 
                            onChange={handleInputChange} 
                        />
                        <i><NameIcon/></i>
                    </div>
                    </div>

                    <div className="">
                    <label htmlFor="message">
                        Gerne können Sie hier ein Foto hochladen:{" "}
                    </label>
                    <div className="">
                        <input type="file" onChange={handleFileChange} accept="image/*" />
                    </div>

                    </div>

                    <div className="datenschutz">
                    Mit * gekennzeichnete Felder sind Pflichtfelder. Bitte beachten Sie unsere <a href="https://www.janker-dach.de/datenschutz/" target="_blank">Datenschutzerklärung.</a>
                    </div>
                    </div>

                 : 
                 null}



                <button type="submit" disabled={isLoading}>
                    {isLoading ? (
                    <div className="loader-html">
                        {!sendDataSuccess ? 
                        <img alt="Loader " src={Spinner} className="loader-img" />
                        : 
                        <i>
                            <CheckIcon/>
                        </i>
                        }
                    </div>
                    ) : (
                    "Abschicken"
                    )}
                    <i><AirplaneIcon/></i>
                </button>

                


                {/*<button type="button" onClick={showQuestionData}>Show</button>*/}
            </form>
        </>
    )
};

export default FormularView;